<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-1 mb-1">
          <label>ID</label>
          <input type="text" class="form-control" v-model="filtro.id" />
        </div>
        <div class="col-md-2 mb-1">
          <label>Unidade solicitada</label>
          <v-select
            v-model="filtro.unidade_solicitada"
            class="vselect"
            :options="unidades"
            :reduce="(unidades) => unidades.id"
            :label="'nome'"
          />
        </div>
        <div class="col-md-2 mb-1">
          <label>Unidade solicitante</label>
          <v-select
            v-model="filtro.unidade_solicitante"
            class="vselect"
            :options="unidades"
            :reduce="(unidades) => unidades.id"
            :label="'nome'"
          />
        </div>
        <div class="col-md-2 mb-1">
          <label>Tipo veículo</label>
          <v-select
            v-model="filtro.tipo_veiculo"
            class="vselect"
            :options="tipo_veiculos"
            :reduce="(tipo_veiculos) => tipo_veiculos.id"
            :label="'nome'"
          />
        </div>
        <div class="col-md-2 mb-1">
          <label>Tipo pedido</label>
          <v-select
            v-model="filtro.sos"
            class="vselect"
            :options="sos"
            :reduce="(sos) => sos.id"
            :label="'text'"
          />
        </div>
        <div class="col-md-2 mb-1">
          <label>Data de criação</label>
          <input type="date" class="form-control" v-model="filtro.date" />
        </div>
        <div class="col-md-1 mb-1">
          <br />
          <button class="btn btn-primary" @click="filtrar()">Filtrar</button>
        </div>
        <div class="col-md-4 d-flex align-items-center">
          <toggle-button
            v-model="atualizarAutomaticamente"
            color="#15488A"
            :height="20"
            :width="40"
            @change="toggleAtualizacao"
          />
          Atualizar automaticamente
        </div>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12 p-1" style="overflow-x: auto">
                  <table class="table table-bordered">
                    <thead class="text-center">
                      <th>ID</th>
                      <th>Unidade solicitada</th>
                      <th>Unidade solicitante</th>
                      <th>Tipo de veículo solicitante</th>
                      <th>Status</th>
                      <th>Tipo</th>
                      <!-- <th>Observações</th> -->
                      <th>Data de criação</th>
                      <th>Ações</th>
                    </thead>
                    <tbody v-for="pedido in pedidos" :key="pedido.id">
                      <td class="text-center">{{ pedido.id }}</td>
                      <td class="text-center">
                        <span class="badge badge-secondary">{{
                          pedido.u_solicitada.nome
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span class="badge badge-secondary">{{
                          pedido.u_solicitante.nome
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge badge-secondary"
                          v-if="pedido.u_solicitante.veiculo"
                          >{{
                            pedido.u_solicitante.veiculo.tipo_veiculo.nome
                          }}</span
                        >
                        <span class="badge badge-danger" v-else
                          >Não informado</span
                        >
                      </td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="'badge-' + pedido.status_class"
                        >
                          {{ pedido.status_f }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span
                          class="badge badge-primary"
                          v-show="pedido.data_inicio && pedido.data_fim"
                          >Pedido semanal</span
                        >
                        <span
                          class="badge badge-warning"
                          v-show="
                            !pedido.data_inicio &&
                            !pedido.data_fim &&
                            !pedido.suplementar &&
                            !pedido.rapido
                          "
                          >Pedido SOS</span
                        >
                        <span
                          class="badge badge-secondary"
                          v-show="
                            !pedido.data_inicio &&
                            !pedido.data_fim &&
                            pedido.suplementar
                          "
                          >Pedido Suplementar</span
                        >
                        <span
                          class="badge badge-secondary"
                          v-show="
                            !pedido.data_inicio &&
                            !pedido.data_fim &&
                            pedido.rapido
                          "
                          >Pedido Rápido</span
                        >
                      </td>
                      <!-- <td class="text-center" v-if="pedido.observacao">
                        <div v-html="pedido.observacao[0].texto"></div>
                      </td>
                      <td class="text-center" v-else><b>Não há observações</b></td> -->
                      <td class="text-center">{{ pedido.created_at_f }}</td>
                      <td class="text-center">
                        <button
                          title="Cancelar pedido"
                          class="btn btn-crud delete"
                          style="margin-left: 4px; margin-top: 4px"
                          @click="abrirModalCancelamento(pedido.id)"
                          v-if="
                            [0, 2, 3, 4, 5, 7, 8, 9, 10, 11].includes(
                              pedido.status
                            )
                          "
                        >
                          <i class="fas fa-times" title="Cancelar pedido"></i>
                        </button>
                        <button
                          title="Consultar"
                          class="btn btn-crud view"
                          style="margin-left: 4px; margin-top: 4px"
                          @click="view(pedido.id)"
                        >
                          <i class="fas fa-eye" title="Consultar"></i>
                        </button>
                        <!-- <button
                          title="Redispensar"
                          class="btn btn-crud redispensar" 
                          style="margin-left: 4px; margin-top: 4px;"
                          @click="redispensar(pedido.id)"
                          v-if="[1, 6, 7].includes(pedido.status)"
                        >
                          <i class="fas fa-redo" title="Redispensar"></i>
                        </button> -->
                        <button
                          title="Gerenciar"
                          class="btn btn-crud key"
                          style="margin-left: 4px; margin-top: 4px"
                          @click="atender(pedido.id)"
                        >
                          <i class="fas fa-clipboard" title="Gerenciar"></i>
                        </button>
                        <button
                          title="Gerar PDF"
                          class="btn btn-crud check"
                          style="margin-left: 4px; margin-top: 4px"
                          @click="pdf(pedido.file)"
                        >
                          <i class="fas fa-file" title="Gerar PDF"></i>
                        </button>
                      </td>
                    </tbody>
                    <tbody
                      class="col-md-12 text-center p-1"
                      style="border: 1px solid #ccc; border-radius: 8px"
                      v-if="!pedidos.length"
                    >
                      <td class="p1" colspan="8">Não há pedidos</td>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div
              class="col-md-6 mt-1 mx-auto d-flex justify-content-center align-items-center"
            >
              <pagination
                :records="total"
                :options="options"
                :per-page="15"
                @paginate="getPedidos"
              ></pagination>
            </div>
            <!-- <div class="card-footer d-flex justify-content-center">
              <div class="btn-group" role="group" aria-label="Basic example">
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  v-if="page > 1"
                  @click="previousPage()"
                >
                  <i class="fas fa-chevron-left"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  v-for="i in range(1, totalPages + 1)"
                  :key="i"
                  @click="goToPage(i)"
                >
                  {{ i }}
                </button>
                <button
                  type="button"
                  class="btn btn-outline-secondary btn-sm"
                  v-if="page < totalPages"
                  @click="nextPage()"
                >
                  <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div> -->
            <div class="ibox-title" style="padding: 16px">
              <div
                class="modal fade"
                id="modalExport"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modalExportTitle"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal-dialog-centered modal-lg"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="exampleModalLongTitle">
                        Exportar
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body mt-1">
                      <div class="alert alert-warning" role="alert">
                        Para exportar todos os registros, basta não definir
                        nenhum intervalo de datas e proceder com a exportação.
                        <button
                          type="button"
                          class="close"
                          data-dismiss="alert"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div class="row">
                        <div class="col-md-6 mb-1">
                          <label>Data de Ínicio</label>
                          <input
                            type="date"
                            class="form-control"
                            v-model="filters.data_inicio"
                          />
                        </div>
                        <div class="col-md-6 mb-1">
                          <label>Data do Fim</label>
                          <input
                            type="date"
                            class="form-control"
                            v-model="filters.data_fim"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Fechar
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="exportToExcel"
                      >
                        Exportar
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal de Justificativa para Cancelamento -->
              <div
                v-if="modalCancelarAberto"
                class="modal fade show"
                id="modalCancelar"
                tabindex="-1"
                role="dialog"
                aria-labelledby="modalCancelarTitle"
                style="display: block"
                @click="fecharModalCancelamento"
              >
                <div class="modal-backdrop fade show"></div>
                <div
                  class="modal-dialog modal-dialog-centered modal-md"
                  role="document"
                  @click.stop
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title" id="modalCancelarTitle">
                        Cancelar Pedido
                      </h5>
                      <button
                        type="button"
                        class="close"
                        @click="fecharModalCancelamento"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>

                    <div class="modal-body mt-1">
                      <div class="alert alert-warning" role="alert">
                        <strong>Atenção:</strong> Esta ação não poderá ser
                        desfeita. Por favor, informe o motivo do cancelamento.
                      </div>
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <label for="justificativa"
                            >Justificativa do Cancelamento *</label
                          >
                          <textarea
                            id="justificativa"
                            class="form-control"
                            v-model="justificativaCancelamento"
                            rows="4"
                            placeholder="Informe o motivo do cancelamento do pedido..."
                            maxlength="500"
                            required
                          ></textarea>
                          <small class="form-text text-muted">
                            {{
                              justificativaCancelamento
                                ? justificativaCancelamento.length
                                : 0
                            }}/500 caracteres
                          </small>
                        </div>
                      </div>
                    </div>

                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        @click="fecharModalCancelamento"
                      >
                        Cancelar
                      </button>
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="confirmarCancelamento"
                        :disabled="!justificativaCancelamento"
                      >
                        Confirmar Cancelamento
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Pagination } from "vue-pagination-2";
export default {
  name: "imageUpload",
  data() {
    return {
      pedidos: [],
      tipo_veiculos: [],
      unidades: [],
      filtro: [],
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      pages: [],
      sos: [
        {
          id: 0,
          text: "Semanal",
        },
        {
          id: 1,
          text: "SOS",
        },
        {
          id: 2,
          text: "Suplementar",
        },
        {
          id: 3,
          text: "Rápido",
        },
      ],
      atualizarAutomaticamente: false,
      pedidosInterval: null,
      filters: {
        data_inicio: null,
        data_fim: null,
      },
      // Variáveis para o modal de cancelamento
      pedidoParaCancelar: null,
      justificativaCancelamento: "",
      modalCancelarAberto: false,
    };
  },
  computed: {},
  components: { Pagination },
  methods: {
    exportToExcel() {
      const self = this;
      const dataInicio = self.filters.data_inicio;
      const dataFim = self.filters.data_fim;

      if (dataInicio || dataFim) {
        if (dataInicio && dataFim) {
          var url = `${self.$store.state.url}exportar_pedidos?data_inicio=${dataInicio}&data_fim=${dataFim} 23:59:59`;
          window.open(url, "_blank").focus();
        } else {
          self.$message(
            null,
            "Por favor, preencha ambos os campos de data.",
            "error"
          );
          return;
        }
      } else {
        var url = `${self.$store.state.url}exportar_pedidos`;
        window.open(url, "_blank").focus();
      }
    },
    range(start, end) {
      return Array.from({ length: end - start }, (_, i) => i + start);
    },
    getPedidos: function (page) {
      const self = this;
      self.page = page || 1;

      let api =
        self.$store.state.api +
        `pedidos?with[]=u_solicitante&with[]=u_solicitada&status=10&orderByDesc=id&page=${self.page}`;

      api += self.filtro.id ? `&id=${self.filtro.id}` : "";
      api += self.filtro.unidade_solicitada
        ? `&unidade_solicitada=${self.filtro.unidade_solicitada}`
        : "";
      api += self.filtro.unidade_solicitante
        ? `&unidade_solicitante=${self.filtro.unidade_solicitante}`
        : "";
      api += self.filtro.date ? `&created_at=${self.filtro.date}` : "";

      if (self.filtro.sos !== null && self.filtro.sos !== undefined) {
        api += `&tipo_pedido=${self.filtro.sos}`;
      }

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          let pedidos = response.data.data;

          if (self.filtro.tipo_veiculo && pedidos?.length) {
            pedidos = pedidos.filter((pedido) => {
              return (
                pedido.u_solicitante.veiculo &&
                pedido.u_solicitante.veiculo.tipo_veiculo_id ===
                  self.filtro.tipo_veiculo
              );
            });
          }

          self.pedidos = pedidos;
          self.total = Number(response.data.count) || 0;

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidades: function () {
      const self = this;
      const api = self.$store.state.api + "unidades?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getTipoVeiculos: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_veiculos?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.tipo_veiculos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    view: function (id) {
      this.$router.push({
        path: "pedidos/view/" + id,
      });
    },
    atender: function (id) {
      this.$router.push({
        path: "pedidos/atender/" + id,
      });
    },
    pdf: function (file) {
      window.open(file, "_blank");
    },
    goToPage: function (page) {
      this.page = page;
      this.getPedidos();
    },
    previousPage: function () {
      this.page--;
      this.getPedidos();
    },
    nextPage: function () {
      this.page++;
      this.getPedidos();
    },
    // Método para abrir o modal de cancelamento
    abrirModalCancelamento: function (id) {
      this.pedidoParaCancelar = id;
      this.justificativaCancelamento = "";
      this.modalCancelarAberto = true;
      // Adicionar classe para impedir scroll do body
      document.body.classList.add("modal-open");
    },
    // Método para fechar o modal de cancelamento
    fecharModalCancelamento: function () {
      this.modalCancelarAberto = false;
      this.limparJustificativa();
      // Remover classe para permitir scroll do body
      document.body.classList.remove("modal-open");
    },
    // Método para limpar a justificativa
    limparJustificativa: function () {
      this.pedidoParaCancelar = null;
      this.justificativaCancelamento = "";
    },
    // Método para confirmar o cancelamento com justificativa
    confirmarCancelamento: function () {
      if (!this.justificativaCancelamento) {
        this.$message(
          "Erro",
          "A justificativa deve ter pelo menos 10 caracteres",
          "error"
        );
        return;
      }

      this.cancelar(this.pedidoParaCancelar, this.justificativaCancelamento);
    },
    // Método cancelar modificado para incluir justificativa
    cancelar: function (id, justificativa = null) {
      const self = this;
      const api = self.$store.state.api + `cancelar/${id}`;

      const data = justificativa ? { justificativa: justificativa } : {};

      axios
        .post(api, data)
        .then((response) => {
          self.$message("Sucesso", `Pedido cancelado com sucesso`, "success");

          // Fechar o modal
          self.fecharModalCancelamento();

          self.getPedidos();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    redispensar: function (id) {
      this.$router.push({
        path: "pedidos/redispensar/" + id,
      });
    },
    filtrar: function () {
      this.getPedidos(1);
    },
    toggleAtualizacao() {
      if (this.atualizarAutomaticamente) {
        this.pedidosInterval = setInterval(() => {
          this.getPedidos();
        }, 30000);
      } else {
        if (this.pedidosInterval) {
          clearInterval(this.pedidosInterval);
          this.pedidosInterval = null;
        }
      }
    },
  },
  beforeDestroy() {
    if (this.pedidosInterval) {
      clearInterval(this.pedidosInterval);
    }
  },
  mounted: function () {
    const self = this;

    self.getPedidos();
    self.getTipoVeiculos();
    self.getUnidades();
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
.key {
  border: 2px solid #ff7301;
}
.key:hover {
  background: #ff7301;
  color: white;
}
.badge-orange {
  background: #d34300;
  color: white;
}
.redispensar {
  border: 2px solid #880088;
  color: #000000;
}
.redispensar:hover,
.badge-purple {
  background: #880088;
  color: white;
}

/* Estilos para o modal de cancelamento */
#modalCancelar {
  z-index: 1050;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
}

.modal-dialog {
  position: relative;
  z-index: 1050;
  margin: 1.75rem auto;
  max-width: 500px;
}

/* Impedir scroll do body quando modal está aberto */
body.modal-open {
  overflow: hidden;
}

/* Estilo para o textarea de justificativa */
#justificativa {
  resize: vertical;
  min-height: 100px;
}

/* Botão desabilitado */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
